import { gql } from 'graphql-request';
import { GlobalQuery } from '@orgnc/core/lib/themes/queries';
import { IRootQuery } from '@orgnc/core/generated/graphql-operations';

export const query = gql`
  query AdvertiseTemplateConfiguration {
    acfOptionsGeneral {
      generalOptions {
        advertiseTemplateConfiguration {
          utmTrackingEntries {
            phonenumberHtml
            utmCampaign
            utmSource
          }
        }
        hubspotConfiguration {
          hubspotFormId
          hubspotFormTitle
          hubspotPortalId
          hubspotRegion
        }
        pageContent {
          siteLogo {
            altText
            caption
            mediaItemUrl
          }
        }
      }
    }
  }
`;

const advertiseTemplateDetailsQuery: GlobalQuery<IRootQuery> = {
  name: 'advertiseTemplateDetailsQuery',
  query,
};

export default advertiseTemplateDetailsQuery;
